import { escapeEntryValue } from './escapeEntryValue';

// Builds the a_FORCE value for an answered entry error: 'FORCE=value' chained
// after the previously accumulated force value ('HIDE+,MAXPRICE=50').
export const buildEntryForceValue = (
  force: string,
  value: string,
  previousForce?: string
): string => {
  const entryPair = `${force}=${escapeEntryValue(value)}`;
  return previousForce ? `${previousForce},${entryPair}` : entryPair;
};
